//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuizGridView from "@/components/quiz/quiz_question/QuizGridView.vue";
import QuizInputView from "@/components/quiz/quiz_question/QuizInputView.vue";

export default {
  name: "QuizQuestionItem",
  created() {},
  props: ["question", "index", "quiz", "quizResultId"],
  data() {
    return {
      fillAnswer: "",
    };
  },
  methods: {
    answer: function (answer) {
      this.question.answer(this.quiz.id, answer, this.quizResultId).then(() => {
        this.$emit("answer");
      });
    },
  },
  components: {
    QuizGridView,
    QuizInputView,
  },
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question/QuizQuestionItem.vue